.gameLobbyWrapper {
  width: 100%;
  height: 100vh;

  background-color: var(--ds-poker-green-darker);

  position: relative;
}

.gameLog {
  position: absolute;
  bottom: 16px;
  right: 16px;
}

.handDrawer {
  position: absolute;
  bottom: 0;

  width: 100%;
  padding: 13px 0;
  background-color: var(--ds-poker-green-lighter);
}
